<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row">
      <div class="col-12">
        <h1>Modelo de contrato</h1>
        <p class="text-muted">
          Texto usado ao gerar o contrato digital de uma locação. As variáveis entre <code v-pre>{{ }}</code> são preenchidas com os dados da locação.
          O modelo padrão é genérico: revise as cláusulas (de preferência com um advogado) antes de usar.
        </p>
      </div>
    </div>
    <hr/>

    <div v-if="loading" class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else class="row g-4">
      <div class="col-lg-8">
        <span v-if="isDefault" class="badge text-bg-light border mb-2">Usando o modelo padrão</span>
        <textarea ref="editor" v-model="template" class="form-control font-monospace" rows="28" aria-label="Texto do contrato"></textarea>
        <div class="d-flex flex-wrap gap-2 mt-3">
          <button class="btn btn-primary" @click="salvar" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Salvar
          </button>
          <button class="btn btn-outline-secondary" @click="restaurar" :disabled="saving">Restaurar modelo padrão</button>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Variáveis</h5>
            <p class="small text-muted">Clique para inserir na posição do cursor.</p>
            <ul class="list-unstyled mb-0">
              <li v-for="(descricao, nome) in variables" :key="nome" class="mb-1">
                <button type="button" class="btn btn-sm btn-link p-0 font-monospace" @click="inserir(nome)" v-text="tag(nome)"></button>
                <div class="small text-muted">{{ descricao }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, nextTick } from 'vue';
import { contracts } from '@/models/contracts';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';

export default {
  name: "ContractTemplateView",
  components: { PainelLayout, Breadcrumb },
  setup() {

    const toastStore = useToastStore();
    const model = contracts();
    const loading = ref(false);
    const saving = ref(false);
    const template = ref('');
    const isDefault = ref(true);
    const variables = ref({});
    const editor = ref(null);

    function preencher(data) {
      template.value = data.template;
      isDefault.value = data.is_default;
      variables.value = data.variables;
    }

    async function salvar() {
      saving.value = true;
      try {
        preencher(await model.updateTemplate(template.value));
        toastStore.success('Modelo salvo. Vale para os próximos contratos gerados.');
      } catch (error) {
        toastStore.error('Erro ao salvar: ' + parseError(error));
      }
      saving.value = false;
    }

    async function restaurar() {
      if (!confirm('Descartar o texto atual e voltar ao modelo padrão?')) return;
      saving.value = true;
      try {
        preencher(await model.updateTemplate(null));
        toastStore.success('Modelo padrão restaurado.');
      } catch (error) {
        toastStore.error(parseError(error));
      }
      saving.value = false;
    }

    // Montado em JS: "}}" dentro de uma interpolação do template fecharia a expressão
    function tag(nome) {
      return '{' + '{' + nome + '}' + '}';
    }

    async function inserir(nome) {
      const el = editor.value;
      const texto = tag(nome);
      const pos = el ? el.selectionStart : template.value.length;
      template.value = template.value.slice(0, pos) + texto + template.value.slice(el ? el.selectionEnd : pos);
      await nextTick();
      if (el) {
        el.focus();
        el.selectionStart = el.selectionEnd = pos + texto.length;
      }
    }

    onMounted(async () => {
      loading.value = true;
      try {
        preencher(await model.getTemplate());
      } catch (error) {
        toastStore.error('Erro ao carregar modelo: ' + parseError(error));
      }
      loading.value = false;
    });

    return { loading, saving, template, isDefault, variables, editor, salvar, restaurar, inserir, tag };
  }
}
</script>
